module.exports = __webpack_public_path__ + "static/img/02.64ca3520.jpg";